import { H2, P } from "@/components/ui";
import React, { FC, ReactNode } from "react";

type Heading2Props = {
  title?: ReactNode;
  subtitle?: ReactNode;
  titleClassName?: string;
  subtitleClassName?: string;
};

export const Heading2: FC<Heading2Props> = ({
  title = "",
  subtitle = "",
  titleClassName = "",
  subtitleClassName = "",
}) => {
  return (
    <>
      <H2 className={titleClassName}>{title}</H2>
      <P className={subtitleClassName}>{subtitle}</P>
    </>
  );
};
